<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_visit`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <visitFilter ref="visitFilter" @filterVisitItem="filterVisitItems"></visitFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <visitList ref="visitList" @setMemberFilter="setMemberFilter" @setExportData="setExportData"></visitList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import VisitFilter from './Visit_Filter'
import VisitList from './Visit_List'

export default {
    name: "reportCredit",
    components:{
        VisitFilter, VisitList, BreadCrumb
    },
    data(){
        return {
            filterObj: {}, 
        }
    },
    methods:{
        filterVisitItems(filterObj){
            this.filterObj = filterObj;
            this.$refs.visitList.setVisitItems(this.filterObj);
        },
        setMemberFilter(data, member){
            this.$refs.visitFilter.setMemberFilter(data, member)
        },
        setExportData(data){
            this.$refs.visitFilter.setExportData(data)
        },
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>